import mod from "-!./GalleryItem.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./GalleryItem.js?vue&type=script&lang=js&external"